import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ExitConfirmationDialog = ({ open, onStay, onExit }) => {
    const { t } = useTranslation('CashWallet');

    return (
        <Dialog open={open} onClose={onStay} className="cash-wallet-exit-dialog">
            <DialogTitle className="cash-wallet-exit-title">{t('Exit.Title')}</DialogTitle>
            <DialogContent>
                <DialogContentText className="cash-wallet-exit-body">{t('Exit.Body')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="cash-wallet-exit-stay" variant="outlined" color="primary" onClick={onStay}>
                    {t('Exit.Stay')}
                </Button>
                <Button className="cash-wallet-exit-exit" variant="outlined" color="danger" onClick={onExit}>
                    {t('Exit.Exit')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ExitConfirmationDialog;
